
import { Options, Vue } from "vue-class-component";
import { namespace } from 'vuex-class';
import CardRh from "@/components/cards/ManzaCard.vue";
import NotaService from "@/service/v1/sigap/NotaService";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from '@vueform/multiselect';
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { User } from "@/store/modules/AuthModule";
import Cadastro from "./_Cadastro.vue";
import { Prop } from 'vue-property-decorator';
import $ from "jquery";

const authStore = namespace('auth');

@Options({
    name: "NotaMatriculaIndex",
    components: { CardRh, KDataTable, Multiselect, Cadastro },
})
export default class NotaMatriculaIndex extends Vue {
    @Prop() readonly matricula!: any;

    @authStore.Getter
    public perfis!: any;

    @authStore.Getter
    public currentUser!: User;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public modelo: any = null;
    public dados: any = null;
    public status_id: any = null;
    public matriculaId: any = null;
    public status: any = null;
    public modal_cadastro_bota: any = 'kt_cadatrar_matricula_avaliacao';
    public search = '';
    public notaMin = '';
    public notaMax = '';
    public disciplinaFiltro = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = '';
        this.status_id = null;
        this.notaMin = '';
        this.notaMax = '';
        this.disciplinaFiltro = '';
        this.refreshTable();
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    pushColunaAcoes(): void {
        this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    created() {
        this.matriculaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new NotaService();
        this.getStatus();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    status: this.status_id,
                    matriculaId: this.matriculaId,
                    disciplina: this.disciplinaFiltro,
                    notaMax: this.notaMax,
                    notaMin: this.notaMin,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[0, 'asc'],[1, 'asc']];
        this.config.columns = [
            { data: 'disciplina.descricao', name: 'disciplina' },
            { data: 'tipo', name: 'tipo' },
            { data: 'notaValor', name: 'notavalor' },
            { data: 'status', name: 'status ' },
        ];

        this.config.columnDefs = [
            {
                targets: 1,
                render: (row) => {
                    return row.nome.replaceAll('_', ' ');
                }
            },
            {
                targets: 3,
                render: (row) => {
                    return row.nome.replaceAll('_', ' ');
                }
            },
        ];

        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push({
                targets: 4,
                render: (row, type, val) => {
                    let texto = '';
                    let buttom = '';
                    for (const key in val) {
                        buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                    }
                    texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-nota ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                    return texto;
                },
            });
        }
    }

    public tableatualizada(): void {
        $('[btn-show-nota]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            const routeData = this.$router.resolve({ name: 'sigap_avaliacao_show', params: { id: id } });
            window.open(routeData.href, '_blank');
        });
    }
}
